import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es6.array.map.js";
import { BANKING_DISPLAY_PAGES, MORTGAGES_CANONICAL_DRIVERS } from '@nerdwallet/marketplace/constants';
import { getDrivers, getName, getNmlsId } from '@nerdwallet/marketplace/selectors/mortgages';
import { mappings as quickFactMappings } from '@nerdwallet/react-quick-facts';
export default (function (_ref) {
  var _driverToQuickFactMap;

  var displayPage = _ref.displayPage,
      marketplaceEntity = _ref.marketplaceEntity,
      minCreditScoreType = _ref.minCreditScoreType;
  // https://github.com/NerdWallet/wp/blob/7ff5bced4ed14e5100359b17fa9e42c30b652030/src/wp-content/mu-plugins/nerdwallet-config/config/meta-fields.json#L1277:L1283
  var driverToQuickFactMappingFunctionMap = (_driverToQuickFactMap = {}, _defineProperty(_driverToQuickFactMap, MORTGAGES_CANONICAL_DRIVERS.CREDIT_SCORE, function () {
    return quickFactMappings.mortgages.getQuickFactMinCreditScore(marketplaceEntity, minCreditScoreType);
  }), _defineProperty(_driverToQuickFactMap, MORTGAGES_CANONICAL_DRIVERS.DOWN_PAYMENT, function () {
    return quickFactMappings.mortgages.getQuickFactMinDownPayment(marketplaceEntity);
  }), _defineProperty(_driverToQuickFactMap, MORTGAGES_CANONICAL_DRIVERS.COVERAGE_AREA, function () {
    return quickFactMappings.mortgages.getQuickFactNationalRegional(marketplaceEntity);
  }), _defineProperty(_driverToQuickFactMap, MORTGAGES_CANONICAL_DRIVERS.LTV, function () {
    return quickFactMappings.mortgages.getQuickFactMaxLtv(marketplaceEntity);
  }), _defineProperty(_driverToQuickFactMap, "minCreditScore", function minCreditScore() {
    return quickFactMappings.mortgages.getQuickFactMinCreditScore(marketplaceEntity, minCreditScoreType);
  }), _defineProperty(_driverToQuickFactMap, "minDownPayment", function minDownPayment() {
    return quickFactMappings.mortgages.getQuickFactMinDownPayment(marketplaceEntity);
  }), _defineProperty(_driverToQuickFactMap, "nationalRegional", function nationalRegional() {
    return quickFactMappings.mortgages.getQuickFactNationalRegional(marketplaceEntity);
  }), _defineProperty(_driverToQuickFactMap, "maxLtv", function maxLtv() {
    return quickFactMappings.mortgages.getQuickFactMaxLtv(marketplaceEntity);
  }), _driverToQuickFactMap);
  var productName = getName(marketplaceEntity);
  var nmlsId = getNmlsId(marketplaceEntity);
  var heading = "".concat(productName, ": NMLS#").concat(nmlsId);
  var drivers = (getDrivers(marketplaceEntity) || []).map(function (driver) {
    return driverToQuickFactMappingFunctionMap[driver].call();
  });

  if (displayPage === BANKING_DISPLAY_PAGES.REVIEWS) {
    drivers.push(quickFactMappings.mortgages.getQuickFactLoanTypesAndProducts(marketplaceEntity));
  }

  return {
    drivers: drivers,
    heading: heading
  };
});